/**
 * Template picker used inside the group form. Selecting a template emits
 * the template's operation set which the parent applies to the checkbox
 * group.
 */

import React from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';

export interface TemplateOption {
  name: string;
  description?: string;
  operations: string[];
  is_system?: boolean;
}

export interface TemplateDropdownProps {
  templates: TemplateOption[];
  onSelect: (name: string) => void;
  disabled?: boolean;
  value?: string;
}

export const TemplateDropdown: React.FC<TemplateDropdownProps> = ({
  templates,
  onSelect,
  disabled,
  value = '',
}) => {
  return (
    <Select
      value={value}
      onChange={(next: string) => onSelect(next)}
      placeholder="Choose a template…"
      disabled={disabled}
      aria-label="Template"
      width={260}
    >
      <SelectOption value="" label="(Custom — no template)" />
      {templates.map((t) => (
        <SelectOption
          key={t.name}
          value={t.name}
          label={t.is_system ? `${t.name} (system)` : t.name}
        />
      ))}
    </Select>
  );
};
